
import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

const Informacoes = (props: { status: string; nf: string; datalancamento: string }) => {
  return (
    <Box
      sx={{
        width: '100%',
        padding: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <InfoOutlined sx={{ fontSize: 20, color: '#0965c1' }} />
        <Typography variant="subtitle1" fontSize="15px" fontWeight={500} sx={{ lineHeight: 1 }}>
          Informações
        </Typography>
      </Box>

      <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2, // espaço entre colunas
        }}
      >
        {/* Coluna Status */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" fontSize="13px" fontWeight={500}>
            Status:
          </Typography>
          <Typography variant="body2" fontSize="13px">{props.status}</Typography>
        </Box>

        {/* Coluna NF */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" fontSize="13px" fontWeight={500}>
            NF:
          </Typography>
          <Typography variant="body2" fontSize="13px">{props.nf}</Typography>
        </Box>

        {/* Coluna Data */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" fontSize="13px" fontWeight={500}>
            Data:
          </Typography>
          <Typography variant="body2" fontSize="13px">{props.datalancamento}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Informacoes;
